// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hx6tI_lYFg6zJrhYejIP{background:var(--action-text-tertiary-normal);border:none;border-radius:6px;outline:none;flex-direction:column;justify-content:center;align-items:center;width:28px;margin:0;padding:5.5px 4px;display:flex}.hx6tI_lYFg6zJrhYejIP:hover,.hx6tI_lYFg6zJrhYejIP.qEWtNPawM5MPti87zhit{background:var(--action-text-secondary-hovered)}.hx6tI_lYFg6zJrhYejIP:hover .kI7_Y6rw8QuwLzCR5V42,.hx6tI_lYFg6zJrhYejIP.qEWtNPawM5MPti87zhit .kI7_Y6rw8QuwLzCR5V42{color:var(--content-brand-secondary)}.kI7_Y6rw8QuwLzCR5V42{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `hx6tI_lYFg6zJrhYejIP`,
	"active": `qEWtNPawM5MPti87zhit`,
	"text": `kI7_Y6rw8QuwLzCR5V42`
};
export default ___CSS_LOADER_EXPORT___;
